module.exports = __webpack_public_path__ + "assets/img/CMTP-Website.b78a5349.webp";